<template>
  <div class="brackets-view">
    <div class="container">
      <Toolbar class="brackets-view__toolbar" title-tag="h1">
        <template #title>
          <span class="visually-hidden">Турнирная сетка</span>
          {{ cityName }}
        </template>
      </Toolbar>

      <AppLoading v-if="bracketLoading" position="center" />
      <BracketView v-else-if="bracket" :bracket="bracket" />
      <AppCard v-else class="brackets-view__message">Сетка отсутствует</AppCard>
    </div>
  </div>
</template>

<script>
import BracketView from "@/components/brackets/BracketView";
import { Toolbar } from "@/components/ui/toolbar/";
import bracketsService from "@/services/brackets";
import { mapState, mapActions } from "vuex";

export default {
  name: "BracketsViewPage",

  components: {
    Toolbar,
    BracketView
  },

  data: () => ({
    loading: true,
    bracketLoading: true,
    bracket: null
  }),

  computed: {
    ...mapState("dictionaries", {
      city({ dictionaries }) {
        const { cities } = dictionaries;
        if (!cities) return;
        return cities.find(item => item.id === this.slug);
      },
      cities: ({ dictionaries }) => dictionaries.cities
    }),

    cityName() {
      return this.city ? this.city.name : "Город";
    },

    slug() {
      return +this.$route.params.slug;
    }
  },

  async created() {
    await this.loadCities();
    this.checkCity();
    this.getBracket();
  },

  methods: {
    ...mapActions("dictionaries", ["getDictionary"]),
    async loadCities() {
      this.loading = true;
      await this.getDictionary("cities");
      this.loading = false;
    },
    checkCity() {
      if (!this.city) {
        this.$router.replace("/404");
      }
    },
    changeCity(citySlug) {
      this.$router.replace({
        name: "teams-category",
        params: { slug: citySlug }
      });
    },
    async getBracket() {
      this.bracketLoading = true;
      const { data, success } = await bracketsService.getBrackets(this.slug);
      if (success) {
        this.bracket = data;
      }
      this.bracketLoading = false;
    }
  },

  breadcrumb() {
    const { cityName, slug } = this;
    return {
      title: cityName,
      to: {
        name: "brackets-view",
        params: { slug }
      }
    };
  }
};
</script>

<style lang="scss">
.brackets-view {
  &__extensions {
    display: flex;
    flex-grow: 1;
    align-items: center;
    flex-wrap: wrap;
  }

  &__toolbar {
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
  }

  &__message {
    color: colors(text-2);
    padding: 30px;
    text-align: center;
    font-size: 20px;
    font-weight: fw(bold);
  }
}
</style>
